import { type Dtos } from "@inrev/common";
import { type FC } from "react";
import { WipAnalysisGrid } from "./WipAnalysisGrid";

export type WipAnalysisPanelProps = {
	extractions: ReadonlyArray<Dtos.Wip.Extraction.Get.Response>;
	lineItems: ReadonlyArray<Dtos.Wip.LineItem.Get.Response>;
	projects: ReadonlyArray<Dtos.Wip.Project.Get.Response>;
	statements: ReadonlyArray<Dtos.Wip.Statement.Get.Response>;
};

export const WipAnalysisPanel: FC<WipAnalysisPanelProps> = ({
	extractions,
	lineItems,
	projects,
	statements,
}) => {
	return (
		<div className="flex flex-1 min-h-0 flex-col" data-testid="wip-analysis-panel">
			<WipAnalysisGrid
				extractions={extractions}
				lineItems={lineItems}
				projects={projects}
				statements={statements}
			/>
		</div>
	);
};
